import validator from 'validator';
import Errors, { MAX_CHAR, MAX_PHONE_NUMBER } from './validateHelper';

const validateTaralite = values => {
  const errors = new Errors();

  if (!values.first_name || values.first_name.trim() === '') {
    errors.first_name = 'Please enter a value';
  }

  if (values.name && values.name.length > MAX_CHAR) {
    errors.name = 'The maximum character is only 255';
  }

  if (!values.last_name || values.last_name.trim() === '') {
    errors.last_name = 'Please enter a value';
  }

  if (values.last_name && values.last_name.length > MAX_CHAR) {
    errors.last_name = 'The maximum character is only 255';
  }

  if (!values.email || values.email.trim() === '') {
    errors.email = 'Please enter a value';
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'The value is not a valid email address';
  } else if (values.email && values.email.length > MAX_CHAR) {
    errors.email = 'The maximum character is only 255';
  }

  if (!values.phone_number || values.phone_number.trim() === '') {
    errors.phone_number = 'Please enter a value';
  } else if (
    values.phone_number &&
    (values.phone_number.length < 9 ||
      values.phone_number.length > MAX_PHONE_NUMBER)
  ) {
    errors.phone_number = 'Please enter a valid phone number';
  }

  if (!values.nik || values.nik.trim() === '') {
    errors.nik = 'Please enter a value';
  } else if (values.nik && values.nik.length !== 16) {
    errors.nik = 'please enter the valid ID';
  }

  if (!values.npwp_no || values.npwp_no.trim() === '') {
    errors.npwp_no = 'Please enter a value';
  } else if (values.npwp_no && values.npwp_no.length !== 15) {
    errors.npwp_no = 'please enter the valid NPWP';
  }

  if (!values.gender || values.gender.trim() === '') {
    errors.gender = 'Please enter a value';
  }

  if (!values.marital_status || values.marital_status.trim() === '') {
    errors.marital_status = 'Please enter a value';
  }

  if (!values.place_of_birth || values.place_of_birth.trim() === '') {
    errors.place_of_birth = 'Please enter a value';
  } else if (values.place_of_birth && values.place_of_birth.length > MAX_CHAR) {
    errors.place_of_birth = 'The maximum character is only 255';
  }

  if (!values.birth_date) {
    errors.birth_date = 'Please enter a value';
  }

  if (!values.mother_name || values.mother_name.trim() === '') {
    errors.mother_name = 'Please enter a value';
  } else if (values.mother_name && values.mother_name.length > MAX_CHAR) {
    errors.mother_name = 'The maximum character is only 255';
  }

  if (!values.address || values.address.trim() === '') {
    errors.address = 'Please enter a value';
  } else if (values.address && values.address.length > MAX_CHAR) {
    errors.address = 'The maximum character is only 255';
  }

  if (!values.home_city || values.home_city.trim() === '') {
    errors.home_city = 'Please enter a value';
  } else if (values.home_city && values.home_city.length > MAX_CHAR) {
    errors.home_city = 'The maximum character is only 255';
  }

  if (!values.home_province || values.home_province.trim() === '') {
    errors.home_province = 'Please enter a value';
  }

  if (!values.home_zipcode || values.home_zipcode.trim() === '') {
    errors.home_zipcode = 'Please enter a value';
  } else if (values.home_zipcode && values.home_zipcode.length !== 5) {
    errors.home_zipcode = 'please enter the valid ZIP Code';
  }

  if (!values.business_name || values.business_name.trim() === '') {
    errors.business_name = 'Please enter a value';
  } else if (values.business_name && values.business_name.length > MAX_CHAR) {
    errors.business_name = 'The maximum character is only 255';
  }

  if (
    !values.business_start_month ||
    values.business_start_month.trim() === ''
  ) {
    errors.business_start_month = 'Please enter a value';
  }

  if (!values.business_start_year || values.business_start_year.trim() === '') {
    errors.business_start_year = 'Please enter a value';
  }

  if (!values.business_address || values.business_address.trim() === '') {
    errors.business_address = 'Please enter a value';
  } else if (
    values.business_address &&
    values.business_address.length > MAX_CHAR
  ) {
    errors.business_address = 'The maximum character is only 255';
  }

  if (!values.business_city || values.business_city.trim() === '') {
    errors.business_city = 'Please enter a value';
  } else if (values.business_city && values.business_city.length > MAX_CHAR) {
    errors.business_city = 'The maximum character is only 255';
  }

  if (!values.business_province || values.business_province.trim() === '') {
    errors.business_province = 'Please enter a value';
  }

  if (!values.business_zipcode || values.business_zipcode.trim() === '') {
    errors.business_zipcode = 'Please enter a value';
  } else if (values.business_zipcode && values.business_zipcode.length !== 5) {
    errors.business_zipcode = 'please enter the valid ZIP Code';
  }

  if (!values.bank_name || values.bank_name.trim() === '') {
    errors.bank_name = 'Please enter a value';
  } else if (
    values.bank_name &&
    values.bank_name === 'Other' &&
    (!values.other_bank_name || values.other_bank_name.trim() === '')
  ) {
    errors.other_bank_name = 'Please enter a value';
  } else if (
    values.other_bank_name &&
    values.other_bank_name.length > MAX_CHAR
  ) {
    errors.other_bank_name = 'The maximum character is only 255';
  }

  if (!values.account_no || values.account_no.trim() === '') {
    errors.account_no = 'Please enter a value';
  } else if (
    values.account_no &&
    (values.account_no.length < 10 || values.account_no.length > 16)
  ) {
    errors.account_no = 'please enter a valid bank account';
  }

  if (!values.bank_account_name || values.bank_account_name.trim() === '') {
    errors.bank_account_name = 'Please enter a value';
  } else if (
    values.bank_account_name &&
    values.bank_account_name.length > MAX_CHAR
  ) {
    errors.bank_account_name = 'The maximum character is only 255';
  }

  if (!values.name_emergency || values.name_emergency.trim() === '') {
    errors.name_emergency = 'Please enter a value';
  } else if (values.name_emergency && values.name_emergency.length > MAX_CHAR) {
    errors.name_emergency = 'The maximum character is only 255';
  }

  if (!values.relationship || values.relationship.trim() === '') {
    errors.relationship = 'Please enter a value';
  } else if (values.relationship && values.relationship.length > MAX_CHAR) {
    errors.name = 'The maximum character is only 255';
  }

  if (
    !values.contact_number_emergency ||
    values.contact_number_emergency.trim() === ''
  ) {
    errors.contact_number_emergency = 'Please enter a value';
  } else if (values.contact_number_emergency.length < 9) {
    errors.contact_number_emergency = 'Please enter a valid phone number';
  }

  if (!values.loan_purpose) {
    errors.loan_purpose = 'Please enter a value';
  } else if (values.loan_purpose.trim() === '') {
    errors.loan_purpose = 'Please enter a value';
  } else if (values.loan_purpose && values.loan_purpose.length > MAX_CHAR) {
    errors.name = 'The maximum character is only 255';
  }

  if (!values.kk || values.kk.code.trim() === '') {
    errors.kk = 'Please upload your kartu keluarga';
  } else if (values.kk && values.kk.code === 'forbiden type') {
    errors.kk = 'Only jpg, jpeg, png, and pdf are accepted';
  } else if (values.kk && values.kk.code === 'file Too Big') {
    errors.kk = 'The maximum file size is only 2MB';
  } else if (values.kk && values.kk.code === 'tampered file') {
    errors.kk = 'The image has been tampered, please upload another one';
  }

  if (!values.ktp || values.ktp.code.trim() === '') {
    errors.ktp = 'Please upload your KTP';
  } else if (values.ktp && values.ktp.code === 'forbiden type') {
    errors.ktp = 'Only jpg, jpeg, png, and pdf are accepted';
  } else if (values.ktp && values.ktp.code === 'file Too Big') {
    errors.ktp = 'The maximum file size is only 2MB';
  } else if (values.ktp && values.ktp.code === 'tampered file') {
    errors.ktp = 'The image has been tampered, please upload another one';
  }

  if (
    !values.verification_photo ||
    values.verification_photo.code.trim() === ''
  ) {
    errors.verification_photo = 'Please upload your verification photo';
  } else if (
    values.verification_photo &&
    values.verification_photo.code === 'forbiden type'
  ) {
    errors.verification_photo = 'Only jpg, jpeg, png, and pdf are accepted';
  } else if (
    values.verification_photo &&
    values.verification_photo.code === 'file Too Big'
  ) {
    errors.verification_photo = 'The maximum file size is only 2MB';
  } else if (
    values.verification_photo &&
    values.verification_photo.code === 'tampered file'
  ) {
    errors.verification_photo =
      'The image has been tampered, please upload another one';
  }

  return errors;
};

export default validateTaralite;
